// pages/Reports.js
import React from 'react';
import { ListGroup } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { getUser } from '../utils/auth';

// 'admin' (Super Admin, full system access) gets the same org-wide
// treatment as masteradmin everywhere reports are scoped.
const COMPANY_HIERARCHY_ROLES = ['masteradmin', 'admin', 'companyadmin', 'departmentadmin'];

const REPORTS = [
  {
    path: '/reports/training-count-summary',
    title: 'Training Count Summary',
    description: 'Count of trainings completed for a selected period.',
    roles: COMPANY_HIERARCHY_ROLES,
  },
  {
    path: '/reports/cancelled-trainings',
    title: 'Cancelled Trainings',
    description: 'Cancelled trainings grouped by cancellation reason, with the underlying list.',
    roles: COMPANY_HIERARCHY_ROLES,
  },
  {
    path: '/reports/course-completion-matrix',
    title: 'Course Completion Matrix',
    description: 'Courses vs. departments — count of current employees who completed each course.',
    roles: COMPANY_HIERARCHY_ROLES,
  },
  {
    path: '/reports/attendance-by-department',
    title: 'Attendance by Department',
    description: 'Employees who attended at least one training, by department — drill into any department for a per-employee breakdown.',
    roles: COMPANY_HIERARCHY_ROLES,
  },
  {
    path: '/reports/training-list-attendance',
    title: 'Training List with Attendance Counts',
    description: 'Trainings within a period and how many employees attended each — trainers see their own trainings, vendor admins see their own vendor’s trainings.',
    roles: [...COMPANY_HIERARCHY_ROLES, 'trainer', 'trainingadmin'],
  },
  {
    path: '/reports/ki-eligibility-matrix',
    title: 'Key Instructor Eligibility Matrix',
    description: 'Courses vs. departments — count of current employees eligible as Key Instructor for each course.',
    roles: COMPANY_HIERARCHY_ROLES,
  },
];

function Reports() {
  const role = getUser()?.role;
  const visibleReports = REPORTS.filter(r => r.roles.includes(role));

  return (
    <div className="p-2">
      <h2>Reports</h2>
      <ListGroup>
        {visibleReports.map(r => (
          <ListGroup.Item key={r.path} action as={Link} to={r.path}>
            <strong>{r.title}</strong>
            <div className="text-muted">{r.description}</div>
          </ListGroup.Item>
        ))}
      </ListGroup>
    </div>
  );
}

export default Reports;
